import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ConnectionManagement extends Component {
  static propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    iconColor: PropTypes.string
  };

  static defaultProps = {
    width: 19.75,
    height: 26,
    iconColor: '#fff'
  };

  render() {
    const { height, width, iconColor } = this.props;

    return (
      <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.75 26">
        <path
          id="Icon_awesome-plug"
          data-name="Icon awesome-plug"
          d="M12.5,7.031V1.563a1.562,1.562,0,1,1,3.125,0V7.031Zm5.469.781H.781A.781.781,0,0,0,0,8.594v1.563a.781.781,0,0,0,.781.781h.781V12.5a7.815,7.815,0,0,0,6.25,7.656V25h3.125V20.156a7.815,7.815,0,0,0,6.25-7.656V10.938h.781a.781.781,0,0,0,.781-.781V8.594A.781.781,0,0,0,17.969,7.812ZM6.25,7.031V1.563a1.563,1.563,0,0,0-3.125,0V7.031Z"
          transform="translate(0.5 0.5)"
          fill="none"
          stroke={iconColor}
          strokeWidth="1"
        />
      </svg>
    );
  }
}
